import { useIsMobile } from '@/hooks/useIsMobile';
import { ProfileCircle } from './ProfileCircle';
import { ItemsDetails } from './ItemsDetails';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { Templates } from '@/types/common';

export const PlayerDetails = ({
  showPurchedItems,
  handleShowPurchedItems,
}: {
  showPurchedItems: boolean;
  handleShowPurchedItems: () => void;
}) => {
  const { offer, template } = useContext(CheckoutContext);
  const isMobile = useIsMobile();
  const isOnePayment = template.type === Templates.OnePayment;
  const shouldShowToggle = isMobile || isOnePayment;
  return (
    <div className="flex flex-row items-center justify-between md:w-5/6 mb-3">
      <div className="flex flex-row items-center gap-3">
        <ProfileCircle />
        <div className="font-semibold">{offer?.displayName ?? offer?.name ?? ''}</div>
      </div>
      {shouldShowToggle && (
        <ItemsDetails showPurchedItems={showPurchedItems} handleShowPurchedItems={handleShowPurchedItems} />
      )}
    </div>
  );
};
